module.exports = __webpack_public_path__ + "static/media/50-iveco-mercedes.bc6009b7.jpg";